import { render, staticRenderFns } from "./create-customer.vue?vue&type=template&id=7675fce9&"
import script from "./create-customer.vue?vue&type=script&lang=ts&"
export * from "./create-customer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports